<template>
	<div>
		<el-tabs tab-position="left" style="height: 500px;" @tab-click="getTabText" v-model="type" class="approver-box">
			<el-tab-pane v-if="cardType !== 2" label="自由选择人员" name="35">自由选择人员后，可在提交申请或审批时从所有员工中自由选择 下一步的审批人</el-tab-pane>
			<el-tab-pane label="员工审核" name="1">
				<el-tabs tab-position="left" style="height: 480px;" v-model="usersType">
					<el-tab-pane label="最近使用" name="1">

					</el-tab-pane>
					<el-tab-pane label="按成员查找" name="2">

					</el-tab-pane>
					<template v-if="usersType == 1">
						<span class="mb5">选择员工</span>
						<checkbox-list :data-source="recentUserOptions" :checked-items="checkedUserIds?checkedUserIds:[]"
						 :showCheckedItemsBox="true" @onchecked="handleCheckListChecked"></checkbox-list>
					</template>
					<template v-if="usersType == 2">
						<span class="mb5">选择员工</span>
						<checkbox-list :data-source="userOptions" :checked-items="checkedUserIds?checkedUserIds:[]" :showCheckedItemsBox="true"
						 @onchecked="handleCheckListChecked"></checkbox-list>
					</template>
					<p style="margin:10px 0 5px 10px;">已选择员工</p>
					<div id="checkedItemsBox" class="checkedItemsBox">
						<p v-for="(item,i) in checkedUsersArr" :key="i" class="itemBox"><span> {{item.name}} </span><i class=" el-icon-close"
							 @click="delCheckedItem(i,item.uuid)"></i></p>
					</div>
				</el-tabs>

			</el-tab-pane>
			<el-tab-pane label="岗位审核" name="2">
				<span class="mb5">选择岗位</span>
				<checkbox-list :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]" :checkboxgroup-height="403"
				 @onchecked="handleCheckedRoles"></checkbox-list>
			</el-tab-pane>
			<el-tab-pane v-if="cardType !== 2" label="提交人" name="26">选择申请人后，本节点的处理人为此流程的发起人</el-tab-pane>
			<el-tab-pane label="本人上级审核" name="3">
				<template v-if="cardType == 2">选择申请人直接上级后，抄送人为流程申请人的直接上级领导</template>
				<template v-else>选择申请人直接上级后，审批人为流程申请人的直接上级领导</template>
			</el-tab-pane>
			<el-tab-pane label="部门主管审核" name="4">
				<el-tabs tab-position="left" style="height: 480px;" @tab-click="getDepartentText" v-model="departmentType" class="departmentBox">
					<el-tab-pane label="本部门" name="0">
						<template v-if="cardType == 2">抄送人为申请人本部门的部门主管</template>
						<template v-else>审批人为申请人本部门的部门主管</template>
					</el-tab-pane>
					<el-tab-pane label="上级部门" name="-1">
						<template v-if="cardType == 2">抄送人为申请人上级部门的部门主管</template>
						<template v-else>审批人为申请人上级部门的部门主管</template>
					</el-tab-pane>
					<el-tab-pane label="表单部门" name="-2">
						<span class="mb5">选择表单部门</span>
						<checkbox-list :data-source="formFieldsOptions" :checked-items="checkedFieldIds?checkedFieldIds:[]"
						 :checkboxgroup-height="cardType == 2 ? 405 : 363" @onchecked="handleCheckedForm"></checkbox-list>
					</el-tab-pane>
					<el-tab-pane label="上个环节审核人所在部门" name="-3">
						<template v-if="cardType == 2">抄送人为上个环节审核人所在部门的主管</template>
						<template v-else>审批人为上个环节审核人所在部门的主管</template>
					</el-tab-pane>
					<el-tab-pane label="所在分公司" name="-4">
						<template v-if="cardType == 2">抄送人为申请人所在分公司的部门主管</template>
						<template v-else>审批人为申请人所在分公司的部门主管</template>
					</el-tab-pane>
					<el-tab-pane label="组织部门" name="5">
						<input class="el-input__inner" v-model="checkedDepartmentsText" placeholder="选择部门" @focus="showDepartmentTree">
					</el-tab-pane>
					<div class="upQueryBox" v-if="cardType !== 2">
						<el-checkbox v-model="upQuery" style="margin-right:3px;">向上查询 </el-checkbox>
						<el-popover placement="top-start" title="" width="300" trigger="hover" content="向上查询：当前所选部门无负责人时，自动选择所选部门的上级部门负责人为审批人，依次向上查询">
							<i class="el-icon-question" slot="reference"></i>
						</el-popover>
					</div>
				</el-tabs>
			</el-tab-pane>
			<el-tab-pane label="部门岗位审核" name="8">
				<el-tabs tab-position="left" style="height: 480px;" @tab-click="getDepartentText" v-model="departmentType" class="departmentBox">
					<el-tab-pane label="本部门" name="0">
						<span class="mb5">选择岗位</span>
						<checkbox-list :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]" :checkboxgroup-height="cardType == 2 ? 405 : 363"
						 @onchecked="handleCheckedRoles"></checkbox-list>
					</el-tab-pane>
					<el-tab-pane label="上级部门" name="-1">
						<span class="mb5">选择岗位</span>
						<checkbox-list :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]" :checkboxgroup-height="cardType == 2 ? 405 : 363"
						 @onchecked="handleCheckedRoles"></checkbox-list>
					</el-tab-pane>
					<el-tab-pane label="表单部门" name="-2">
						<span class="mb5">选择表单部门</span>
						<checkbox-list :data-source="formFieldsOptions" :checked-items="checkedFieldIds?checkedFieldIds:[]"
						 :checkboxgroup-height="150" @onchecked="handleCheckedForm"></checkbox-list>
						<span class="mb5">选择岗位</span>
						<checkbox-list style="margin-top:10px;" :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]"
						 :checkboxgroup-height="cardType == 2 ? 180 : 130" @onchecked="handleCheckedRoles"></checkbox-list>
					</el-tab-pane>
					<el-tab-pane label="上个环节审核人所在部门" name="-3">
						<span class="mb5">选择岗位</span>
						<checkbox-list :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]" :checkboxgroup-height="cardType == 2 ? 405 : 363"
						 @onchecked="handleCheckedRoles"></checkbox-list>
					</el-tab-pane>
					<el-tab-pane label="所在分公司" name="-4">
						<span class="mb5">选择岗位</span>
						<checkbox-list :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]" :checkboxgroup-height="cardType == 2 ? 405 : 363"
						 @onchecked="handleCheckedRoles"></checkbox-list>
					</el-tab-pane>
					<el-tab-pane label="组织部门" name="5" class="organDepartment-box">
						<span class="mb5">选择部门</span>
						<input class="el-input__inner" v-model="checkedDepartmentsText" placeholder="选择部门" @focus="showDepartmentTree">
						<span class="mb5">选择岗位</span>
						<checkbox-list :data-source="roleOptions" :checked-items="checkedRoleIds?checkedRoleIds:[]" :checkboxgroup-height="cardType == 2 ? 335 : 286"
						 @onchecked="handleCheckedRoles"></checkbox-list>
					</el-tab-pane>
					<div class="upQueryBox" v-if="cardType != 2">
						<el-checkbox v-model="upQuery" style="margin-right:3px;">向上查询 </el-checkbox>
						<el-popover placement="top-start" title="" width="300" trigger="hover" content="向上查询：当前所选部门无负责人时，自动选择所选部门的上级部门负责人为审批人，依次向上查询">
							<i class="el-icon-question" slot="reference"></i>
						</el-popover>
					</div>
				</el-tabs>
			</el-tab-pane>
			<el-tab-pane label="表单员工" name="27">
				<span class="mb5">选择表单员工</span>
				<checkbox-list :data-source="formFieldsOptions" :checked-items="checkedFieldIds?checkedFieldIds:[]"
				 :checkboxgroup-height="398" @onchecked="handleCheckedForm"></checkbox-list>
			</el-tab-pane>
		</el-tabs>
		<div style="text-align: right;">
			<el-button type="primary" size="small" @click="handleClickApprover" style="margin-top:10px;">确定</el-button>
		</div>
		<div v-if="dialogDepartmentVisible">
			<el-dialog title="选择部门" :visible.sync="dialogDepartmentVisible" :append-to-body="true">
				<el-tree :data="treeData" show-checkbox default-expand-all node-key="id" ref="tree" highlight-current :props="defaultProps"
				 :default-checked-keys="checkedDepartmentIds">
				</el-tree>
				<div style="text-align: right;margin-top:20px;">
					<el-button size="small" @click="dialogDepartmentVisible = false">取消</el-button>
					<el-button type="primary" size="small" @click="handleClickDepartment">确定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import CheckboxList from "./CheckboxList";

	import userService from "../service/flowChart/userService";
	import postService from "../service/flowChart/postService";
	import departmentService from "../service/flowChart/departmentService";
	import workflowService from "../service/flowChart/workflowService";

	export default {
		components: {
			CheckboxList
		},
		props: {
			cardType: {
				type: Number
			},
			defaultCheckeduserids: {
				type: Array,
				default: () => []
			},
			defaultCheckedformfieldids: {
				type: Array,
				default: () => []
			},
			defaultCheckeddepartmentids: {
				type: Array,
				default: () => []
			},
			defaultCheckedroleids: {
				type: Array,
				default: () => []
			},
			defaultType: {
				type: String,
			},
			defaultTitle: {
				type: String
			},
			defaultUpquery: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				upQuery: this.defaultUpquery,
				type: this.defaultType,
				title: this.defaultTitle,
				departmentTitle: '',
				checkedUserIds: this.defaultCheckeduserids,
				checkedDepartmentIds: this.defaultCheckeddepartmentids,
				checkedRoleIds: this.defaultCheckedroleids,
				checkedFieldIds: this.defaultCheckedformfieldids,
				departmentType: '',
				usersType: '2',
				checkedUsersArr: [],
				defaultProps: {
					children: 'children',
					label: 'text'
				},
				treeData: [],
				dialogDepartmentVisible: false,
				userOptions: [],
				roleOptions: [],
				formFieldsOptions: [],
			}
		},
		computed: {
			checkedDepartmentsText: function() {
				let nodes = [];
				let _this = this;
				let findCheckedTreeText = node => {
					node.forEach((obj, i) => {
						if (_this.checkedDepartmentIds.indexOf(obj.id) != -1) {
							nodes.push(obj.text)
						}
						if (obj.children && obj.children.length > 0) {
							findCheckedTreeText(obj.children)
						}
					})
				};
				findCheckedTreeText(this.treeData);
				return nodes
			},
			recentUserOptions: function() {
				if (localStorage.getItem("localData") !== null) {
					return JSON.parse(localStorage.getItem("localData"));
				}
			},
		},
		async mounted() {
			let userResp = await userService.getUserOptions();
			if (userResp.data.Status === "1") {
				this.userOptions = userResp.data.Data;
			}
			let roleResp = await postService.getRoleOptions();
			if (roleResp.data.Status === "1") {
				this.roleOptions = roleResp.data.Data;
			}
			let treeResp = await departmentService.getTreeData();
			if (treeResp.data) {
				this.treeData = treeResp.data
			}
			let formFieldsResp = await workflowService.getFormFieldsOptions(this.$route.query.id || 1);
			if (formFieldsResp.data.Status === "1") {
				this.formFieldsOptions = formFieldsResp.data.Data;
			}
			let departmentsArr = this.defaultCheckeddepartmentids;
			if ((departmentsArr[0] == 0 || departmentsArr[0] == -1 || departmentsArr[0] == -3 || departmentsArr[0] == -4 ||
					departmentsArr[0] == -2) && departmentsArr.length == 1) {
				this.departmentType = this.defaultCheckeddepartmentids.join(',');
			} else {
				this.departmentType = '5';
			}
			this.checkedUsersArr = this.userOptions.filter(item => this.checkedUserIds.indexOf(item.uuid) != -1);
		},
		watch: {
			defaultType(newVal, oldVal) {
				this.type = newVal;
			},
			defaultCheckeduserids(newVal, oldVal) {
				this.checkedUserIds = newVal;
			},
			defaultCheckeddepartmentids(newVal, oldVal) {
				this.checkedDepartmentIds = newVal;
			},
			defaultCheckedroleids(newVal, oldVal) {
				this.checkedRoleIds = newVal;
			},
			defaultTitle(newVal, oldVal) {
				this.title = newVal;
			},
			defaultCheckedformfieldids(newVal, oldVal) {
				this.checkedFieldIds = newVal;
			},
		},
		methods: {
			delCheckedItem(index, uuid) {
				this.checkedUsersArr.splice(index, 1);
				this.checkedUserIds.splice(this.checkedUserIds.indexOf(uuid), 1);
			},
			handleClickDepartment() {
				this.checkedDepartmentIds = this.$refs.tree.getCheckedNodes().map(item => item.id);
				this.dialogDepartmentVisible = false;

			},
			handleClickApprover() {
				let departmentsArr = [];
				if (this.departmentType != 5) { //如果选中的不是组织部门
					this.checkedDepartmentIds = [this.departmentType];
					departmentsArr = [{
						uuid: this.departmentType,
						name: this.departmentTitle
					}];
				} else {
					this.checkedDepartmentIds.forEach((item, i) => {
						departmentsArr.push({
							uuid: item,
							name: this.checkedDepartmentsText[i]
						})
					})
				}
				this.$emit('onchangeapprover', {
					checkedUsers: this.userOptions.filter(item => this.checkedUserIds.some(ele => ele === item.uuid)),
					checkedDepartments: departmentsArr,
					checkedRoles: this.roleOptions.filter(item => this.checkedRoleIds.some(ele => ele === item.uuid)),
					checkedFields: this.formFieldsOptions.filter(item => this.checkedFieldIds.some(ele => ele === item.uuid)),
					type: this.type,
					title: this.title,
					upQuery: this.upQuery,
				});
			},
			handleCheckListChecked(obj) {
				if (this.usersType === '1') {
					let localAllItems = [];
					if (this.recentUserOptions.length > 0) {
						localAllItems = this.recentUserOptions.map(item => {
							return item.uuid
						})
					}
					if (!this.checkedUserIds) this.checkedUserIds = [];
					let deleteLocalAllItems = this.checkedUserIds.filter(item => localAllItems.indexOf(item) == -1);
					this.checkedUserIds = deleteLocalAllItems.concat(obj.checkedOptions.map(item => {
						return item.uuid
					}))
				} else if (this.usersType === '2') {
					this.checkedUserIds = obj.checkedOptions.map(item => {
						return item.uuid
					});
					let localData = obj.checkedOptions;
					localStorage.setItem("localData", JSON.stringify(localData));
				}
				this.checkedUsersArr = this.userOptions.filter(item => this.checkedUserIds.indexOf(item.uuid) != -1);
			},
			handleCheckedForm(obj) {
				this.checkedFieldIds = obj.checkedOptions.map(item => item.uuid);
			},
			handleCheckedRoles(obj) {
				this.checkedRoleIds = obj.checkedOptions.map(item => item.uuid);
			},
			showDepartmentTree() {
				this.dialogDepartmentVisible = true;
			},
			getTabText(item) {
				this.title = item.label;
				if (item.name === "4" || item.name === "8"){
					this.getFormDeptOption();
				} else if (item.name === "27"){
					this.getFormUserOptions();
				}
				this.checkedUserIds = [];
				this.checkedFieldIds = [];
				this.checkedRoleIds = [];
				this.checkedDepartmentIds = [];
			},
			async getDepartentText(item) {
				this.departmentTitle = item.label;
			},
			async getFormDeptOption() {
				let formFieldsResp = await workflowService.getFormFieldsOptions(this.$route.query.id || 1,"dropdownlist","base_department");
				if (formFieldsResp.data.Status === "1") {
					this.formFieldsOptions = formFieldsResp.data.Data;
				}
			},
			async getFormUserOptions() {
				let formFieldsResp = await workflowService.getFormFieldsOptions(this.$route.query.id || 1,"dropdownlist","base_staff");
				if (formFieldsResp.data.Status === "1") {
					this.formFieldsOptions = formFieldsResp.data.Data;
				}
			},
		}
	}
</script>
<style>
	.departmentBox>.el-tabs__content {
		height: 480px;
	}

	.upQueryBox .el-icon-question {
		font-size: 14px !important;
	}

	.upQueryBox {
		position: absolute;
		bottom: 10px;
	}

	.checkedItemsBox {
		padding: 5px;
		width: 96%;
		height: 100px;
		border: 1px solid #ddd;
		border-radius: 5px;
		margin: 0 auto;
		overflow-y: auto;
	}

	.checkedItemsBox p {
		background: #f4f4f5;
		border-color: #e9e9eb;
		color: #909399;
		padding: 2px 26px 2px 8px;
		border-radius: 4px;
		position: relative;
		display: inline-block;
		margin: 2px 6px 2px 0;
	}

	.itemBox i {
		background-color: #c0c4cc;
		color: #999999;
		cursor: pointer;
		position: absolute;
		right: 4px;
		top: 6px;
		border-radius: 50%;
		padding: 1px;
		font-size: 10px;
	}

	.itemBox i:hover {
		color: #fff;
	}

	.el-input__inner:hover {
		border-color: #C0C4CC;
	}

	.el-input__inner {
		-webkit-appearance: none;
		background-color: #FFF;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		width: 100%;
		cursor: pointer;
		margin-bottom:0;
	}
</style>
